import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const privacyContent = {
  title: 'Política de Privacidad',
  sections: [{
    heading: 'Información que recopilamos',
    text: 'Recopilamos únicamente la información necesaria para procesar tu compra: nombre, correo electrónico y datos de pago. No almacenamos información de tarjetas de crédito directamente; estos datos son procesados de forma segura por nuestro proveedor de pagos.'
  }, {
    heading: 'Uso de la información',
    text: 'Tu información se utiliza exclusivamente para: entregar el producto digital adquirido, enviar actualizaciones relacionadas con tu compra y mejorar nuestros servicios. No vendemos, alquilamos ni compartimos tu información personal con terceros.'
  }, {
    heading: 'Cookies',
    text: 'Utilizamos cookies esenciales para el funcionamiento del sitio y cookies analíticas para entender cómo los visitantes interactúan con nuestra página. Puedes desactivar las cookies en la configuración de tu navegador.'
  }, {
    heading: 'Protección de datos',
    text: 'Implementamos medidas de seguridad técnicas y organizativas para proteger tu información personal contra acceso no autorizado, pérdida o alteración.'
  }, {
    heading: 'Tus derechos',
    text: 'Tienes derecho a acceder, rectificar o eliminar tus datos personales en cualquier momento. Para ejercer estos derechos, puedes contactarnos a través de los canales disponibles.'
  }]
};
const termsContent = {
  title: 'Términos y Condiciones',
  sections: [{
    heading: 'Producto digital',
    text: 'Al realizar tu compra, recibirás acceso inmediato al producto digital "Adolescencia Sin Miedo". Este es un producto educativo en formato digital (PDF/ebook) y no constituye asesoramiento psicológico profesional.'
  }, {
    heading: 'Uso personal',
    text: 'El contenido adquirido es para uso personal y no puede ser reproducido, distribuido, modificado o compartido sin autorización expresa. Queda prohibida la reventa o redistribución del material.'
  }, {
    heading: 'Política de reembolso',
    text: 'Ofrecemos una garantía de satisfacción. Si no estás conforme con el producto, puedes solicitar un reembolso dentro de los 30 días posteriores a la compra, sin preguntas.'
  }, {
    heading: 'Limitación de responsabilidad',
    text: 'Este producto tiene fines educativos e informativos. No reemplaza la atención psicológica, médica o terapéutica profesional. Los resultados pueden variar según cada familia y situación particular.'
  }, {
    heading: 'Modificaciones',
    text: 'Nos reservamos el derecho de actualizar estos términos en cualquier momento. Los cambios serán efectivos desde su publicación en esta página. El uso continuado del sitio implica la aceptación de los términos actualizados.'
  }]
};
function LegalModal({
  isOpen,
  onClose,
  content
}: {
  isOpen: boolean;
  onClose: () => void;
  content: {
    title: string;
    sections: {
      heading: string;
      text: string;
    }[];
  };
}) {
  return <AnimatePresence data-id="element-57">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-58">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} transition={{
        duration: 0.25
      }} className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-59">
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100" data-id="element-60">
              <h2 className="text-xl font-bold text-[#1A2744]" data-id="element-61">
                {content.title}
              </h2>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors text-[#4A5568]" aria-label="Cerrar" data-id="element-62">
                <XIcon size={18} data-id="element-63" />
              </button>
            </div>

            <div className="px-6 py-5 overflow-y-auto max-h-[calc(80vh-64px)] space-y-6" data-id="element-64">
              {content.sections.map((section, i) => <div key={i} data-id="element-65">
                  <h3 className="text-sm font-bold text-[#1A2744] uppercase tracking-wide mb-2" data-id="element-66">
                    {section.heading}
                  </h3>
                  <p className="text-sm text-[#4A5568] leading-relaxed" data-id="element-67">
                    {section.text}
                  </p>
                </div>)}
              <p className="text-xs text-[#718096] pt-2 border-t border-gray-100" data-id="element-68">
                Última actualización: Enero 2025
              </p>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-[#0F1729] text-[#4A5568] text-center py-8 px-5 text-sm" data-id="element-69">
        <p data-id="element-70">
          © 2025 Adolescencia Sin Miedo · Todos los derechos reservados ·{' '}
          <button onClick={() => setActiveModal('privacy')} className="text-[#8AA0C0] hover:underline cursor-pointer bg-transparent border-none" data-id="element-71">
            Política de Privacidad
          </button>{' '}
          ·{' '}
          <button onClick={() => setActiveModal('terms')} className="text-[#8AA0C0] hover:underline cursor-pointer bg-transparent border-none" data-id="element-72">
            Términos y Condiciones
          </button>
        </p>
        <p className="mt-3 text-xs text-[#2D3748]" data-id="element-73">
          Este producto tiene fines educativos. No reemplaza la atención
          psicológica profesional.
        </p>
      </footer>

      <LegalModal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} content={privacyContent} data-id="element-74" />
      <LegalModal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} content={termsContent} data-id="element-75" />
    </>;
}